const VITE_NODE_SERVER_BASE_URL = window.location?.origin?.includes?.(`localhost`) ?
  `http://127.0.0.1:8081` :
  `https://dev-node.carchaser.ca`;

export {
  VITE_NODE_SERVER_BASE_URL
}